/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { isHTMLElement } from "@adapptio/lib-shared";
import { getOwnerWindow } from "./getOwnerWindow";

export interface IScroll {
	scrollLeft: number;
	scrollTop: number;
}

export function getElementScroll(node: Node | Window): IScroll {
	const win = getOwnerWindow(node as Node);

	if (node === win || !isHTMLElement(node)) {
		return {
			scrollLeft: win.scrollX,
			scrollTop: win.scrollY
		};
	}

	return {
		scrollLeft: node.scrollLeft,
		scrollTop: node.scrollTop
	};
}
